// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonLink-module--button--2kr5q","text":"ButtonLink-module--text--mW4mE"};